import { normalizar } from './format'

/** Si `consulta` aparece en alguno de los `campos`, con la tolerancia que
 *  se espera de un buscador escrito rápido en el teléfono:
 *
 *  - palabra por palabra y en cualquier orden: "congelada frambuesa"
 *    encuentra "Frambuesa congelada";
 *  - sin tildes ni mayúsculas: "arandano" encuentra "Arándano";
 *  - sin depender de los espacios: "1kg" encuentra "1 kg" y "nue kg"
 *    encuentra el código "NUE-KG".
 *
 *  Antes cada buscador comparaba el texto completo tal cual, así que
 *  bastaba escribir las palabras en otro orden, o el peso pegado al
 *  número, para que no apareciera nada. */
export function coincide(
  consulta: string,
  ...campos: (string | number | null | undefined)[]
): boolean {
  const palabras = normalizar(consulta).split(/\s+/).filter(Boolean)
  if (!palabras.length) return true
  const texto = normalizar(campos.filter((c) => c !== null && c !== undefined && c !== '').join(' '))
  const compacto = texto.replace(/[\s-]+/g, '')
  return palabras.every((p) => texto.includes(p) || compacto.includes(p.replace(/-/g, '')))
}
